import { render, staticRenderFns } from "./ExtraFieldTextOptionsMetaDataSelect.vue?vue&type=template&id=7831380a&scoped=true"
import script from "./ExtraFieldTextOptionsMetaDataSelect.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldTextOptionsMetaDataSelect.vue?vue&type=script&lang=ts"
import style0 from "./ExtraFieldTextOptionsMetaDataSelect.vue?vue&type=style&index=0&id=7831380a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7831380a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7831380a')) {
      api.createRecord('7831380a', component.options)
    } else {
      api.reload('7831380a', component.options)
    }
    module.hot.accept("./ExtraFieldTextOptionsMetaDataSelect.vue?vue&type=template&id=7831380a&scoped=true", function () {
      api.rerender('7831380a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ExtraFieldTextOptionsMetaDataSelect.vue"
export default component.exports